
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M452 653v171q0 12.75 8.675 21.375 8.676 8.625 21.5 8.625 12.825 0 21.325-8.625T512 824V653l61 61q3 3 15-2t22.5-9q10.5-4 14.5-3.5T615 714q9-9 8.5-21t-9.5-21L501 562q-5-5-10.133-7-5.134-2-11-2Q474 553 469 555q-5 2-10 7L347 674q-9 9-9 21t9 21.391Q356 725 368 725t21-9l63-63zM220 976q-24 0-42-18t-18-42V236q0-24 18-42t42-18h336q12.444 0 23.722 5T599 194l183 183q8 8 13 19.278 5 11.278 5 23.722v496q0 24-18 42t-42 18H220zm331-584V236H220v680h520V422H581q-12.75 0-21.375-8.625T551 392zM220 236v186-186 680-680z"}})])
          )
        }
      }
    